"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formControl = void 0;
var react_1 = require("@emotion/react");
exports.formControl = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 120px;\n"], ["\n  min-width: 120px;\n"])));
var templateObject_1;
//# sourceMappingURL=Select.style.js.map